import {
  IListColumn,
  IListColumnInternalList,
} from 'app/services/api5-service/api.interface';

interface SeparatedColumns {
  simpleColumns: IListColumn[];
  internalLists: IListColumnInternalList[];
}

/**
 * Separate BE columns into two lists
 * - simple columns. Just columns metadata
 * - internal lists. BE have no mechanism to send row-related lists. So the send it as column... yea...
 *
 * @param columns - BE columns metadata
 */
export function separateListColumns(columns: IListColumn[]): SeparatedColumns {
  return columns.reduce<SeparatedColumns>(
    (separated, column) => {
      if (column.$type === 'list') {
        separated.internalLists.push(column);
      } else {
        separated.simpleColumns.push(column);
      }
      return separated;
    },
    {
      simpleColumns: [],
      internalLists: [],
    },
  );
}
